module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "survey-detail-container"
  }, [_c('div', {
    staticClass: "survey-title"
  }, [_vm._v("患者满意度调查问卷")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('van-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('div', {
    staticClass: "survey-section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("一、基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("1. 您的性别：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.gender),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "gender", $$v)
      },
      expression: "surveyData.gender"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "2"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("2. 您的年龄段：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.ageRange),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "ageRange", $$v)
      },
      expression: "surveyData.ageRange"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "18岁以下"
    }
  }, [_vm._v("18岁以下")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "18-30岁"
    }
  }, [_vm._v("18-30岁")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "31-50岁"
    }
  }, [_vm._v("31-50岁")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "51-65岁"
    }
  }, [_vm._v("51-65岁")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "65岁以上"
    }
  }, [_vm._v("65岁以上")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("3. 您的就诊类型：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.visitType),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "visitType", $$v)
      },
      expression: "surveyData.visitType"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "门诊"
    }
  }, [_vm._v("门诊")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "住院"
    }
  }, [_vm._v("住院")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "急诊"
    }
  }, [_vm._v("急诊")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("4. 您本次就诊的科室：")]), _vm._v(" "), _c('van-field', {
    staticClass: "custom-disabled",
    attrs: {
      "placeholder": "请输入科室",
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.department),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "department", $$v)
      },
      expression: "surveyData.department"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "survey-section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("二、诊疗环节评价")]), _vm._v(" "), _c('div', {
    staticClass: "sub-section-title"
  }, [_vm._v("（一）挂号服务")]), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("1. 您对医院挂号渠道的便捷性评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.registrationChannelConvenience),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "registrationChannelConvenience", $$v)
      },
      expression: "surveyData.registrationChannelConvenience"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常便捷"
    }
  }, [_vm._v("非常便捷")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "便捷"
    }
  }, [_vm._v("便捷")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不便捷"
    }
  }, [_vm._v("不便捷")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不便捷"
    }
  }, [_vm._v("非常不便捷")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("2. 您对挂号等待时间的满意度：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.registrationWaitTimeSatisfaction),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "registrationWaitTimeSatisfaction", $$v)
      },
      expression: "surveyData.registrationWaitTimeSatisfaction"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-section-title"
  }, [_vm._v("（二）检查服务")]), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("1. 您对检查项目预约流程的便捷性评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.checkupAppointmentConvenience),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "checkupAppointmentConvenience", $$v)
      },
      expression: "surveyData.checkupAppointmentConvenience"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常便捷"
    }
  }, [_vm._v("非常便捷")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "便捷"
    }
  }, [_vm._v("便捷")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不便捷"
    }
  }, [_vm._v("不便捷")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不便捷"
    }
  }, [_vm._v("非常不便捷")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("2. 您对检验查血等待时间的满意度：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.bloodTestWaitTimeSatisfaction),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "bloodTestWaitTimeSatisfaction", $$v)
      },
      expression: "surveyData.bloodTestWaitTimeSatisfaction"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("3. 您对超声检查等待时间的满意度：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.ultrasoundWaitTimeSatisfaction),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "ultrasoundWaitTimeSatisfaction", $$v)
      },
      expression: "surveyData.ultrasoundWaitTimeSatisfaction"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("4. 您对放射检查（DR或CT）等待时间的满意度：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.radiologyWaitTimeSatisfaction),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "radiologyWaitTimeSatisfaction", $$v)
      },
      expression: "surveyData.radiologyWaitTimeSatisfaction"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("5. 您对检查科室医务人员的服务态度评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.checkupStaffAttitude),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "checkupStaffAttitude", $$v)
      },
      expression: "surveyData.checkupStaffAttitude"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("6. 您对检查结果出具及时性的满意度：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.checkupResultTimeliness),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "checkupResultTimeliness", $$v)
      },
      expression: "surveyData.checkupResultTimeliness"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-section-title"
  }, [_vm._v("（三）诊疗服务")]), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("1. 您对接诊医生的服务态度评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.doctorAttitude),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "doctorAttitude", $$v)
      },
      expression: "surveyData.doctorAttitude"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("2. 您对医生解释病情、治疗方案及注意事项的清晰程度评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.doctorExplanationClarity),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "doctorExplanationClarity", $$v)
      },
      expression: "surveyData.doctorExplanationClarity"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常清晰"
    }
  }, [_vm._v("非常清晰")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "清晰"
    }
  }, [_vm._v("清晰")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不清晰"
    }
  }, [_vm._v("不清晰")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不清晰"
    }
  }, [_vm._v("非常不清晰")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("3. 您对治疗效果的满意度：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.treatmentEffectSatisfaction),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "treatmentEffectSatisfaction", $$v)
      },
      expression: "surveyData.treatmentEffectSatisfaction"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-section-title"
  }, [_vm._v("（四）住院服务（住院患者填写）")]), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("1. 您对住院手续办理流程的便捷性评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.admissionConvenience),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "admissionConvenience", $$v)
      },
      expression: "surveyData.admissionConvenience"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常便捷"
    }
  }, [_vm._v("非常便捷")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "便捷"
    }
  }, [_vm._v("便捷")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不便捷"
    }
  }, [_vm._v("不便捷")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不便捷"
    }
  }, [_vm._v("非常不便捷")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("2. 您对病房环境的评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.wardEnvironment),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "wardEnvironment", $$v)
      },
      expression: "surveyData.wardEnvironment"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("3. 您对护士的服务态度评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.nurseAttitude),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "nurseAttitude", $$v)
      },
      expression: "surveyData.nurseAttitude"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("4. 您对出院手续办理便捷性及出院指导的满意度：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.dischargeConvenience),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "dischargeConvenience", $$v)
      },
      expression: "surveyData.dischargeConvenience"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-section-title"
  }, [_vm._v("（五）取药服务")]), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("1. 您对取药等待时间的满意度：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.pharmacyWaitTimeSatisfaction),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "pharmacyWaitTimeSatisfaction", $$v)
      },
      expression: "surveyData.pharmacyWaitTimeSatisfaction"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("2. 您对药房工作人员服务态度的评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.pharmacyStaffAttitude),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "pharmacyStaffAttitude", $$v)
      },
      expression: "surveyData.pharmacyStaffAttitude"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "survey-section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("三、整体评价")]), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("1. 您对医院就医环境的评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.hospitalEnvironment),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "hospitalEnvironment", $$v)
      },
      expression: "surveyData.hospitalEnvironment"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("2. 您对医院标识指引的清晰程度评价：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.hospitalSignageClarity),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "hospitalSignageClarity", $$v)
      },
      expression: "surveyData.hospitalSignageClarity"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常清晰"
    }
  }, [_vm._v("非常清晰")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "清晰"
    }
  }, [_vm._v("清晰")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不清晰"
    }
  }, [_vm._v("不清晰")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不清晰"
    }
  }, [_vm._v("非常不清晰")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("3. 您对医院的整体服务满意度：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.overallSatisfaction),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "overallSatisfaction", $$v)
      },
      expression: "surveyData.overallSatisfaction"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常满意"
    }
  }, [_vm._v("非常满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "满意"
    }
  }, [_vm._v("满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "一般"
    }
  }, [_vm._v("一般")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不满意"
    }
  }, [_vm._v("不满意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不满意"
    }
  }, [_vm._v("非常不满意")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_c('span', {
    staticClass: "must"
  }, [_vm._v("* ")]), _vm._v("4. 您是否会向亲友推荐本院就诊：")]), _vm._v(" "), _c('van-radio-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.recommendationWillingness),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "recommendationWillingness", $$v)
      },
      expression: "surveyData.recommendationWillingness"
    }
  }, [_c('van-radio', {
    attrs: {
      "name": "非常愿意"
    }
  }, [_vm._v("非常愿意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "愿意"
    }
  }, [_vm._v("愿意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不确定"
    }
  }, [_vm._v("不确定")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "不愿意"
    }
  }, [_vm._v("不愿意")]), _vm._v(" "), _c('van-radio', {
    attrs: {
      "name": "非常不愿意"
    }
  }, [_vm._v("非常不愿意")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "survey-section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("四、意见与建议")]), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("1. 您认为本院在医疗服务中最需要改进的方面是（可多选）：")]), _vm._v(" "), _c('van-checkbox-group', {
    staticClass: "option-group",
    attrs: {
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.improvementsNeeded),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "improvementsNeeded", $$v)
      },
      expression: "surveyData.improvementsNeeded"
    }
  }, [_c('van-checkbox', {
    attrs: {
      "name": "挂号便捷性",
      "shape": "square"
    }
  }, [_vm._v("挂号便捷性")]), _vm._v(" "), _c('van-checkbox', {
    attrs: {
      "name": "就诊等待时间",
      "shape": "square"
    }
  }, [_vm._v("就诊等待时间")]), _vm._v(" "), _c('van-checkbox', {
    attrs: {
      "name": "检查检验等待时间",
      "shape": "square"
    }
  }, [_vm._v("检查检验等待时间")]), _vm._v(" "), _c('van-checkbox', {
    attrs: {
      "name": "取药等待时间",
      "shape": "square"
    }
  }, [_vm._v("取药等待时间")]), _vm._v(" "), _c('van-checkbox', {
    attrs: {
      "name": "医务人员服务态度",
      "shape": "square"
    }
  }, [_vm._v("医务人员服务态度")]), _vm._v(" "), _c('van-checkbox', {
    attrs: {
      "name": "检查和治疗效果",
      "shape": "square"
    }
  }, [_vm._v("检查和治疗效果")]), _vm._v(" "), _c('van-checkbox', {
    attrs: {
      "name": "医院就医环境",
      "shape": "square"
    }
  }, [_vm._v("医院就医环境")]), _vm._v(" "), _c('van-checkbox', {
    attrs: {
      "name": "医院标识指引",
      "shape": "square"
    }
  }, [_vm._v("医院标识指引")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('van-field', {
    staticClass: "custom-disabled",
    attrs: {
      "label": "其他：",
      "placeholder": "请输入其他需要改进的方面",
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.improvementsNeededOther),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "improvementsNeededOther", $$v)
      },
      expression: "surveyData.improvementsNeededOther"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("2. 您对本院医疗服务还有其他具体意见或建议：")]), _vm._v(" "), _c('van-field', {
    staticClass: "custom-disabled",
    attrs: {
      "type": "textarea",
      "placeholder": "请输入您的意见或建议",
      "rows": "3",
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.otherSuggestions),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "otherSuggestions", $$v)
      },
      expression: "surveyData.otherSuggestions"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('div', {
    staticClass: "question-text"
  }, [_vm._v("3. 为了后续和您沟通相关反馈信息，请自愿留下您的联系方式：")]), _vm._v(" "), _c('van-field', {
    staticClass: "custom-disabled",
    attrs: {
      "placeholder": "请输入您的联系方式",
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.surveyData.contactInfo),
      callback: function($$v) {
        _vm.$set(_vm.surveyData, "contactInfo", $$v)
      },
      expression: "surveyData.contactInfo"
    }
  })], 1)]), _vm._v(" "), (_vm.readOnly && _vm.survey.feedBack) ? _c('div', {
    staticClass: "survey-section"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("五、平台反馈")]), _vm._v(" "), _c('div', {
    staticClass: "question-item"
  }, [_c('van-field', {
    staticClass: "custom-disabled",
    attrs: {
      "type": "textarea",
      "placeholder": "请输入您的意见或建议",
      "rows": "3",
      "disabled": _vm.readOnly
    },
    model: {
      value: (_vm.survey.feedBack),
      callback: function($$v) {
        _vm.$set(_vm.survey, "feedBack", $$v)
      },
      expression: "survey.feedBack"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.readOnly) ? _c('div', {
    staticStyle: {
      "margin": "16px"
    }
  }, [_c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "native-type": "submit"
    }
  }, [_vm._v("提交")])], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "survey-description"
  }, [_c('p', [_vm._v("尊敬的患者：")]), _vm._v(" "), _c('p', [_vm._v("\n            您好！欢迎来到我院就诊，为进一步提升医疗服务质量，改善您的就医体验，现诚挚邀请您参与本次满意度调查。您的每一条反馈都将成为我们优化服务的重要依据，问卷采用匿名形式，数据仅用于统计分析，恳请您客观真实填写。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c151c74c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/survey/SurveyDetail.vue
// module id = 873
// module chunks = 0